<template>
  <div class="st-svg"></div>
</template>

<script>
export default {
  props: ['rootFolder', 'platform'],
  data () {
    return {
      svgElem: null,
      originalAspectRatio: 1
    }
  },
  mounted () {
    this.$loading.withLoading(this.fetchXML)()

  },
  destroyed () {
    window.removeEventListener('resize', this.onPageResize)
  },
  methods: {
    fetchXML () {
      return fetch(require(`images/${this.rootFolder}/${this.platform}.svg`))
      .then(res => res.text())
      .then((xml) => {
        var xmlNode = new DOMParser().parseFromString(xml, 'image/svg+xml')
        this.svgElem = this.$el.appendChild(this.processSvg(xmlNode))
        this.$emit('onGetSvg', this.svgElem)
        this.onPageResize()
        window.addEventListener('resize', this.onPageResize)
      }).catch(err => console.log(err))
    },
    processSvg (xml, i) {
      var svgNode = document.importNode(xml.documentElement, true)
      var [,, originalWidth, originalHeight] = svgNode.getAttribute('viewBox').split(' ')
      this.originalAspectRatio = originalHeight / originalWidth
      Array.from(svgNode.querySelectorAll('image'))
        .forEach(img => img.setAttribute('xlink:href', require(`images/${this.rootFolder}/${img.getAttribute('xlink:href')}`)))
      return svgNode
    },
    onPageResize () {
      var newWidth = this.$el.clientWidth
      var newHeight = newWidth * this.originalAspectRatio
      this.svgElem.style.width = newWidth + 'px'
      this.svgElem.style.height = newHeight + 'px'
    }
  }
}
</script>

<style lang="scss">
.st-svg {
  margin: 0 auto;
}
</style>
